import {
  ACTIVITY_LOG_FAILED,
  ACTIVITY_LOG_INVALID_REQUEST,
  ACTIVITY_LOG_SUCCESS,
  ACTIVITY_LOG_NOT_FOUND,
  RESET_ACTIVITY_LOG,
  NETWORK_ERROR_ACTIVITY_LOG,
  LOADING_ACTIVITY_LOG,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  notFound: false,
  networkError: "",
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ACTIVITY_LOG:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        success: false,
        notFound: false,
        networkError: "",
      };
    case ACTIVITY_LOG_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        failed: true,
        networkError: "",
        data: action.payload,
      };
    case ACTIVITY_LOG_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        notFound: false,
        failed: false,
        networkError: "",
        data: action.payload,
      };
    case ACTIVITY_LOG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        notFound: false,
        networkError: "",
        data: state.data.concat(action.payload),
      };

    case NETWORK_ERROR_ACTIVITY_LOG:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        notFound: false,
        invalidRequest: false,
        networkError: "Something went wrong..",
      };

    case ACTIVITY_LOG_NOT_FOUND: {
      console.log(action);
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        notFound: true,
        invalidRequest: false,
        networkError: "",
        data: !action.fromFilter && state.data.length ? state.data : [],
      };
    }

    case RESET_ACTIVITY_LOG:
      return (state = initialState);

    default:
      return state;
  }
};
